// Se calcula sobre el resultado completo, antes de la paginación y sin subtotales.
export function summarizeDetailSteps(rows = []) {
  let total = null;
  const byPeaje = new Map();
  rows.forEach((row) => {
    if (row.tipoFila && row.tipoFila !== "detalle") return;
    const raw = row.totalPasos ?? row.total_pasos;
    if (raw == null || raw === "" || !Number.isFinite(Number(raw))) return;
    const steps = Number(raw);
    total = (total ?? 0) + steps;
    byPeaje.set(row.peaje, (byPeaje.get(row.peaje) ?? 0) + steps);
  });
  return { total, byPeaje };
}
